import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-28 md:pt-32 pb-16">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
                {t("footerPrivacy")}
              </h1>
            </div>

            <div className="space-y-8">
              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Information We Collect</h2>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  This website is a static informational resource. We do not collect personal information through forms, accounts, or registration systems. We do not store user data, login credentials, or payment information.
                </p>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  Like most websites, we may use basic analytics tools that collect anonymous information such as your browser type, approximate location, and pages visited. This data is used solely to improve website performance and user experience.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Cookies</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  We use cookies to store your language preference and cookie consent status. These cookies are essential for providing a localized experience and are not used for tracking or advertising purposes. You can clear cookies at any time through your browser settings.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">External Links</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  This website contains links to external websites, including kaspreadsheet.com. We are not responsible for the privacy practices or content of external websites. We encourage you to review the privacy policies of any third-party sites you visit.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Data Sharing</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  We do not sell, trade, or share any personal information with third parties. Any analytics data collected is anonymized and used only for internal website improvement purposes.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
                <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">Changes to This Policy</h2>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  We may update this privacy policy from time to time. Any changes will be posted on this page with an updated effective date. We encourage you to review this policy periodically.
                </p>
              </div>

              <div className="p-6 md:p-8 rounded-2xl bg-accent-50/50 border border-accent-200/50">
                <p className="text-sm text-foreground-700 leading-relaxed font-medium">
                  Last updated: August 25, 2026. If you have any questions about this privacy policy, please contact us.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}